/**
 * Ajuda — Primeiros passos e acesso.
 *
 * TODO o conteúdo da Ajuda vive como DADOS (não JSX) de propósito: quando a
 * Cleo assumir esta aba, estes arquivos viram a base de conhecimento dela sem
 * reescrever nada. Ícones são NOMES (string) resolvidos na página.
 */
export const primeirosPassos = {
  id: "primeiros-passos",
  titulo: "Primeiros passos",
  icone: "Rocket",
  intro: "Como entrar, o que cada área faz e por onde começar a configurar sua loja.",
  topicos: [
    {
      pergunta: "Como faço login no sistema?",
      resposta: "O administrador entra com o TELEFONE DO ESTABELECIMENTO e a senha criada no cadastro. Funcionários entram com o próprio telefone e a senha definida em Pessoas → Funcionários. O endereço é o do seu painel: sualoja.usenucleo.com.br.",
      videos: ["A4OClLoSHSg"],
    },
    {
      pergunta: "Qual a ordem ideal pra configurar a loja recém-criada?",
      resposta: "1) Configurações → Horários: defina os horários de funcionamento. 2) Localização → Bairros: cadastre os bairros e as taxas de entrega. 3) Cardápio → Produtos: crie categorias e produtos (ou importe de outro sistema em Configurações → Sistema → Integração). 4) Financeiro → Formas de Pagamento: ative o que você aceita. 5) Configurações → Sistema → Impressão: conecte a impressora. 6) ChatBot: conecte o WhatsApp para a Cleo atender por você.",
      videos: ["WXDvR6pvCPM"],
    },
    {
      pergunta: "O que é o cardápio online e qual o link da minha loja?",
      resposta: "É a vitrine pública onde o cliente monta o pedido sozinho, sem instalar nada. O link é o mesmo do painel: sualoja.usenucleo.com.br. Divulgue esse link no Instagram, no WhatsApp e no Google — todo pedido feito nele cai direto em Vendas → Pedidos.",
    },
    {
      pergunta: "Qual a diferença entre os canais de venda?",
      resposta: "Cardápio online: o cliente pede sozinho pelo link. ChatBot: a Cleo atende no WhatsApp e envia o link do cardápio. Delivery: sua equipe lança pedidos por telefone/balcão com endereço. Mesas: comandas para atendimento no salão. Balcão: PDV rápido de retirada, com modo Totem de autoatendimento. Todos os pedidos se encontram em Vendas → Pedidos.",
    },
    {
      pergunta: "O que muda entre os planos Start e Completo?",
      resposta: "O plano Start libera o essencial: pedidos, cardápio online, mesas, caixa e relatórios básicos. O Completo adiciona a Cleo (IA no WhatsApp), estoque e custos (CMV), balcão/totem, KDS, campanhas, fornecedores e despesas. Itens bloqueados aparecem no menu com um selo do plano — dá pra ver tudo e decidir com calma; a troca de plano é em Configurações → Assinatura.",
    },
    {
      pergunta: "Funciona no celular?",
      resposta: "Sim. O painel é responsivo: no celular o menu vira uma lista no botão do canto superior. Existe também o aplicativo de computador (desktop), recomendado pra loja que imprime cupom — é ele que conversa com a impressora.",
    },
    {
      pergunta: "Fechei a loja mais cedo hoje. Como paro de receber pedidos?",
      resposta: "Use o botão de fechar a loja no topo do painel (ou em Configurações → Horários). O cardápio online avisa que a loja está fechada e o checkout é bloqueado; a Cleo também passa a informar o horário de reabertura. Ao reabrir, tudo volta ao normal — não precisa mexer nos horários da semana.",
    },
  ],
};
